import React from "react";

interface IconProps {
    active?: boolean;
    size?: number;
}

/** Sidebar section icon — stroke style shared with the mobile tab bar. */
const IconHome: React.FC<IconProps> = ({ active = false, size = 24 }) => {
    const color = active ? "#0F7679" : "#6A7878";
    return (
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 9.5L10 4l7 5.5V17H3z"/><path d="M8 17v-5h4v5"/>
        </svg>
    );
};

export default IconHome;
